import tw, { styled } from 'twin.macro';

export const Btn = styled.button`
  ${tw`hidden md:block  absolute z-50 -right-12 top-1/2 -translate-y-1/2`}
  img {
    pointer-events: none;
  }
`;
